import React, { useState, useEffect } from "react";
import g1 from "../assets/css/Updatedgallery/galley1.jpeg";
import g2 from "../assets/css/Updatedgallery/galley2.jpeg";
import g3 from "../assets/css/Updatedgallery/galley3.jpeg";
import g4 from "../assets/css/Updatedgallery/galley4.jpeg";
import g5 from "../assets/css/Updatedgallery/galley5.jpeg";
import g6 from "../assets/css/Updatedgallery/galley6.jpeg";
import g7 from "../assets/css/Updatedgallery/galley7.jpeg";
import g8 from "../assets/css/Updatedgallery/galley8.jpeg";
import g9 from "../assets/css/Updatedgallery/galley9.jpeg";
import g10 from "../assets/css/Updatedgallery/galley10.jpeg";
import g11 from "../assets/css/Updatedgallery/galley11.jpeg";
import g12 from "../assets/css/Updatedgallery/galley12.jpeg";
import g13 from "../assets/css/Updatedgallery/galley13.jpeg";
import g14 from "../assets/css/Updatedgallery/galley14.jpeg";
import g15 from "../assets/css/Updatedgallery/galley15.jpeg";
import g16 from "../assets/css/Updatedgallery/galley16.jpeg";
import g17 from "../assets/css/Updatedgallery/galley17.jpeg";
import g18 from "../assets/css/Updatedgallery/galley18.jpeg";
import g19 from "../assets/css/Updatedgallery/galley19.jpeg";
import g20 from "../assets/css/Updatedgallery/galley20.jpeg";
import g21 from "../assets/css/Updatedgallery/galley21.jpeg";
import g22 from "../assets/css/Updatedgallery/galley22.jpeg";
import g23 from "../assets/css/Updatedgallery/galley23.jpeg";
import g24 from "../assets/css/Updatedgallery/gallery24.jpeg";
import g25 from "../assets/css/Updatedgallery/gallery25.jpeg";
import g26 from "../assets/css/Updatedgallery/gallery26.jpeg";
import g27 from "../assets/css/Updatedgallery/gallery27.jpeg";
import g28 from "../assets/css/Updatedgallery/gallery28.jpeg";
import g29 from "../assets/css/Updatedgallery/gallery29.jpeg";
import g30 from "../assets/css/Updatedgallery/gallery30.jpeg";
import g31 from "../assets/css/Updatedgallery/galley31.jpeg";
import g32 from "../assets/css/Updatedgallery/galley32.jpeg";
import g33 from "../assets/css/Updatedgallery/galley33.jpeg";
import g34 from "../assets/css/Updatedgallery/galley34.jpeg";
import g35 from "../assets/css/Updatedgallery/galley35.jpeg";

const INITIAL_COUNT = 8;

function Gallery() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const images = [
    { src: g1, category: "a" },
    { src: g2, category: "a" },
    { src: g3, category: "a" },
    { src: g4, category: "a" },
    { src: g5, category: "a" },
    { src: g6, category: "a" },
    { src: g7, category: "a" },
    { src: g8, category: "a" },
    { src: g9, category: "b" },
    { src: g10, category: "b" },
    { src: g11, category: "b" },
    { src: g12, category: "b" },
    { src: g13, category: "b" },
    { src: g14, category: "b" },
    { src: g15, category: "b" },
    { src: g16, category: "b" },
    { src: g17, category: "a" },
    { src: g18, category: "a" },
    { src: g19, category: "a" },
    { src: g20, category: "b" },
    { src: g21, category: "b" },
    { src: g22, category: "a" },
    { src: g23, category: "a" },
    { src: g24, category: "a" },
    { src: g25, category: "a" },
    { src: g26, category: "a" },
    { src: g27, category: "b" },
    { src: g28, category: "b" },
    { src: g29, category: "b" },
    { src: g30, category: "b" },
    { src: g31, category: "b" },
    { src: g32, category: "b" },
    { src: g33, category: "b" },
    { src: g34, category: "b" },
    { src: g35, category: "b" },
  ];

  const filteredImages =
    activeFilter === "all"
      ? images
      : images.filter((img) => img.category === activeFilter);

  const visibleImages = showAll ? filteredImages : filteredImages.slice(0, INITIAL_COUNT);

  const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(filteredImages[index].src);
    document.body.style.overflow = "hidden";
  };

  const closeImage = () => {
    setSelectedImage(null);
    setCurrentIndex(0);
    document.body.style.overflow = "auto";
  };

  const nextImage = () => {
    const newIndex =
      currentIndex === filteredImages.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex].src);
  };

  const prevImage = () => {
    const newIndex =
      currentIndex === 0 ? filteredImages.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex].src);
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (!selectedImage) return;
      if (e.key === "Escape") closeImage();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedImage, currentIndex]);

  return (
    <>
      <section className="team-one" id="gallery">
        <div className="section-padding gallery-section mb-50">
          <div className="container">

            {/* Title */}
            <div className="block-title text-center">
              <h2 className="section-title__title mb-30">Our Gallery</h2>
            </div>

            {/* Filter Buttons */}
            <div id="btncontainer" className="filter">
              <button
                className={`btn ${activeFilter === "all" ? "btn-active" : ""}`}
                onClick={() => { setActiveFilter("all"); setCurrentIndex(0); setShowAll(false); closeImage(); }}
              >
                ALL
              </button>
              <button
                className={`btn ${activeFilter === "a" ? "btn-active" : ""}`}
                onClick={() => { setActiveFilter("a"); setCurrentIndex(0); setShowAll(false); closeImage(); }}
              >
                Multi Family
              </button>
              <button
                className={`btn ${activeFilter === "b" ? "btn-active" : ""}`}
                onClick={() => { setActiveFilter("b"); setCurrentIndex(0); setShowAll(false); closeImage(); }}
              >
                Single Family
              </button>
            </div>

            {/* Gallery Grid */}
            <div className="gallery">
              {visibleImages.map((img, index) => (
                <button
                  key={img.src}
                  type="button"
                  className="gallery-card"
                  onClick={() => openImage(index)}
                  aria-label={`View image ${index + 1}`}
                >
                  <div className="gallery-card__inner">
                    <img src={img.src} alt={`Gallery ${index + 1}`} />
                    <div className="gallery-card__overlay">
                      <i className="fas fa-expand-alt gallery-card__icon"></i>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            {/* Show More / Show Less */}
            {filteredImages.length > INITIAL_COUNT && (
              <div className="text-center" style={{ marginTop: "28px" }}>
                <button
                  className="btn gallery-showmore-btn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "Show Less" : `Show More (${filteredImages.length - INITIAL_COUNT} more)`}
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Lightbox (Same behavior as screenshot) */}
      {selectedImage && (
        <div className="openDiv" onClick={closeImage}>
          <span className="closeBtn" onClick={closeImage}>×</span>

          <img
            src={selectedImage}
            className="imgPreview"
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
          />

          <div className="butonsSection" onClick={(e) => e.stopPropagation()}>
            <button className="prevButton" onClick={prevImage}>
              Previous
            </button>
            <button className="nextButton" onClick={nextImage}>
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Gallery;
